import React from 'react';
import { useStyles } from './CloseButton.style';

// To make the href empty without TS warnings
const EMPTY = '';

interface IProps {
    onClickEventHandler(val: boolean): void;
}

export default function CloseButton({ onClickEventHandler }: IProps) {
    const classes = useStyles();

    function handleOnClickEvent(e: React.MouseEvent) {
        e.preventDefault();
        onClickEventHandler(false);
    }

    return (
        <a
            href={EMPTY}
            className={classes.wrapper}
            onClick={(e: React.MouseEvent) => {
                handleOnClickEvent(e);
            }}
        >
            <span className={classes.left}>Luk</span>
            <span className={classes.right}>
                <span className={`${classes.cross} crossOver`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14.142" height="14.142" viewBox="0 0 14.142 14.142">
                        <g id="Group" transform="translate(0.759 -6.345) rotate(45)">
                            <path
                                id="Line_3"
                                data-name="Line 3"
                                d="M0,.5H18"
                                transform="translate(14.45 -3.977) rotate(90)"
                                fill="none"
                                stroke="currentColor"
                                strokeMiterlimit="10"
                                strokeWidth="2"
                            />
                            <path
                                id="Line_3-2"
                                data-name="Line 3"
                                d="M0,.5H18"
                                transform="translate(4.95 4.523)"
                                fill="none"
                                stroke="currentColor"
                                strokeMiterlimit="10"
                                strokeWidth="2"
                            />
                        </g>
                    </svg>
                </span>
                <span className={`${classes.arrow} arrowOver`}>
                    <flos-icon shape="arrow" dir="down" />
                </span>
            </span>
        </a>
    );
}
